var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{staticClass:"align-center justify-center",attrs:{"contained":""},model:{value:(_vm.overlay),callback:function ($$v) {_vm.overlay=$$v},expression:"overlay"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"140","width":10}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }